export const validateRange = (min, max) => num => {
  if (num <= 100 && num >= 1) {
    return true;
  }

  return false;
};
export const validateZoom = validateRange(1, 100);